/**
 * 用紙詳細
 */
import { onReady, queryAll } from '@/utils/dom'
import { fadeIn, fadeOut, hide } from '@/utils/fade'

const OVERLAY_ID = 'j-modal_ovrly'
const ESCAPE_KEY = 'Escape'

/**
 * マウスオーバーによるサンプル画像の切り替え
 */
const initImageToggle = (): void => {
    queryAll('.j-tgl_img_thum').forEach((thumb) => {
        thumb.addEventListener('mouseenter', () => {
            const toggleImg = thumb.closest('.paper-img')?.querySelector<HTMLImageElement>('.j-tgl_img')
            const thumbSrc = thumb.querySelector(':scope > img')?.getAttribute('src')
            if(toggleImg && thumbSrc) {
              //初期化（img を隠す）後、サムネイルの画像に書換えて表示
                hide(toggleImg)
                toggleImg.setAttribute('src', thumbSrc)
                fadeIn(toggleImg)
            }
          //サムネイルの外枠を初期化
            thumb.closest('.paper-img_thum')
                ?.querySelectorAll('.j-tgl_img_thum')
                .forEach((elm) => elm.classList.remove('is-select'))
        })
    })
}

/**
 * 各モーダルウィンドウ制御系
 */
const initModals = (): void => {
    let modalState = false
    const overlay = document.getElementById(OVERLAY_ID)

    const openModal = (modal: HTMLElement | null): void => {
        modalState = true
        if(modal) fadeIn(modal, 'flex')
        if(overlay) fadeIn(overlay, 'flex')
    }

    const closeModal = (): void => {
        if(!modalState) return
        queryAll(`.j-modal_paper, #${OVERLAY_ID}`).forEach((elm) => fadeOut(elm))
        modalState = false
    }

  //サムネイル画像拡大表示
    queryAll('.j-modal_tgl-image').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            const modal = document.getElementById('paper-modal-image')
            const img = trigger.querySelector('img')
            const caption = img?.dataset.caption ?? ''
          //モーダル内の要素を調整
            const title = modal?.querySelector('#paper-modal-image-title')
            if(title) title.textContent = caption
            const modalImg = modal?.querySelector('img')
            if(modalImg && img) {
                modalImg.setAttribute('src', img.getAttribute('src') ?? '')
                modalImg.setAttribute('alt', caption)
            }
            openModal(modal)
        })
    })

  //夾雑物などの用紙個別用画像
    queryAll('.j-modal_tgl-item').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            openModal(document.getElementById(`paper-modal-${trigger.id.replace('j-modal_tgl-', '')}`))
        })
    })

  //注文ページリンクリスト
    queryAll('.j-modal_tgl-item_list').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault()
            openModal(document.getElementById('paper-modal-item-list'))
        })
    })

  //非表示処理（クリック・Esc キー）
    queryAll(`.j-modal_close, #${OVERLAY_ID}`).forEach((closer) => {
        closer.addEventListener('click', closeModal)
    })
    window.addEventListener('keyup', (event) => {
        if(event.key===ESCAPE_KEY) closeModal()
    })
}

onReady(() => {
    initImageToggle()
    initModals()
})
